import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import CategoryGrid from "./components/CategoryGrid";
import BestSellers from "./components/BestSellers";
import BuyingGuide from "./components/BuyingGuide";
import BlogSection from "./components/BlogSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <CategoryGrid />
        <BestSellers />
        <BuyingGuide />
        <BlogSection />
        <div id="faq">
          <FAQSection />
        </div>
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}